import { simpleFetch } from './customFetch';

export const getCarriers = () =>
  simpleFetch('/api/1/orders/carriers', {}, process.env.REACT_APP_MY_ACCOUNT_API);
